var _polygon, _rect, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _rect2, _rect3, _polygon8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPB6(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 990 720"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.1",
    points: "269 381 365 381 365 391.67 391 391.67 391 544 269 544 269 381"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.6.2",
    x: 76,
    y: 381,
    width: 188,
    height: 163
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.3",
    points: "162 376 89.16 376 89.16 207 264 207 264 339.29 162 339.29 162 376"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.4",
    points: "269 194 391 194 391 339 294.71 339 294.71 328 269 328 269 194"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.5",
    points: "395.8 194 518 194 518 328 492 328 492 339 395.8 339 395.8 194"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.6",
    points: "523.14 194 646 194 646 339 550 339 550 328 523.14 328 523.14 194"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.7",
    points: "650 176 773 176 773 328 746 328 746 339 650 339 650 176"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.8",
    points: "776.83 176 914 176 914 310 901 310 901 376 776.83 376 776.83 176"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.6.9",
    x: 748.88,
    y: 381,
    width: 152.12,
    height: 132
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    "data-id": "B.6.10",
    x: 649.91,
    y: 381,
    width: 94.09,
    height: 132
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    "data-id": "B.6.11",
    points: "645.54 381 645.54 525 523 525 523 391.67 550 391.67 550 381 645.54 381"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgICB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDk5MCA3MjAiPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjYuMSIgcG9pbnRzPSIyNjkgMzgxIDM2NSAzODEgMzY1IDM5MS42NyAzOTEgMzkxLjY3IDM5MSA1NDQgMjY5IDU0NCAyNjkgMzgxIi8+CgoKICAgIDxyZWN0IGRhdGEtaWQ9IkIuNi4yIiB4PSI3NiIgeT0iMzgxIiB3aWR0aD0iMTg4IiBoZWlnaHQ9IjE2MyIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjYuMyIgcG9pbnRzPSIxNjIgMzc2IDg5LjE2IDM3NiA4OS4xNiAyMDcgMjY0IDIwNyAyNjQgMzM5LjI5IDE2MiAzMzkuMjkgMTYyIDM3NiIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjYuNCIgcG9pbnRzPSIyNjkgMTk0IDM5MSAxOTQgMzkxIDMzOSAyOTQuNzEgMzM5IDI5NC43MSAzMjggMjY5IDMyOCAyNjkgMTk0Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNi41IiBwb2ludHM9IjM5NS44IDE5NCA1MTggMTk0IDUxOCAzMjggNDkyIDMyOCA0OTIgMzM5IDM5NS44IDMzOSAzOTUuOCAxOTQiLz4KCgogICAgPHBvbHlnb24gZGF0YS1pZD0iQi42LjYiIHBvaW50cz0iNTIzLjE0IDE5NCA2NDYgMTk0IDY0NiAzMzkgNTUwIDMzOSA1NTAgMzI4IDUyMy4xNCAzMjggNTIzLjE0IDE5NCIvPgoKCiAgICA8cG9seWdvbiBkYXRhLWlkPSJCLjYuNyIgcG9pbnRzPSI2NTAgMTc2IDc3MyAxNzYgNzczIDMyOCA3NDYgMzI4IDc0NiAzMzkgNjUwIDMzOSA2NTAgMTc2Ii8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNi44IiBwb2ludHM9Ijc3Ni44MyAxNzYgOTE0IDE3NiA5MTQgMzEwIDkwMSAzMTAgOTAxIDM3NiA3NzYuODMgMzc2IDc3Ni44MyAxNzYiLz4KCgogICAgPHJlY3QgZGF0YS1pZD0iQi42LjkiIHg9Ijc0OC44OCIgeT0iMzgxIiB3aWR0aD0iMTUyLjEyIiBoZWlnaHQ9IjEzMiIvPgoKCiAgICA8cmVjdCBkYXRhLWlkPSJCLjYuMTAiIHg9IjY0OS45MSIgeT0iMzgxIiB3aWR0aD0iOTQuMDkiIGhlaWdodD0iMTMyIi8+CgoKICAgIDxwb2x5Z29uIGRhdGEtaWQ9IkIuNi4xMSIgcG9pbnRzPSI2NDUuNTQgMzgxIDY0NS41NCA1MjUgNTIzIDUyNSA1MjMgMzkxLjY3IDU1MCAzOTEuNjcgNTUwIDM4MSA2NDUuNTQgMzgxIi8+Cgo8L3N2Zz4=";
export { SvgPB6 as ReactComponent };